import React, { Component } from 'react';
import Typography from '@mui/material/Typography';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    Brush,
    AreaChart,
    Area,
    ResponsiveContainer,
} from 'recharts';



class OilTempChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newData: [],
            i: 1,
        }
    }

    componentDidMount() {

        this.interval = setInterval(() => {

            var updatedData = [{
                date: new Date().toLocaleString(),
                uv: 18 + Math.round(Math.random() * 2),
                temp: 23 + Math.round(Math.random() * 4),
                amt: 21 + Math.round(Math.random() * 3)
            }]

            this.setState({
                newData: [...this.state.newData, ...updatedData],
                i: this.state.i + 1,
            })
            console.log(this.state.newData)
        }, 1000);

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <ResponsiveContainer width="100%" height={200}>
                    <AreaChart
                        width={500}
                        height={200}
                        data={this.state.newData}
                        syncId="anyId"
                        margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Area type="monotone" dataKey="temp" stroke="#82ca9d" fill="#82ca9d" />
                        {/* <Brush /> */}
                    </AreaChart>
                </ResponsiveContainer>

                <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{ display: { xs: 'none', sm: 'block' } }}
                >
                    <a href="">See full report</a>
                </Typography>
            </div>
        );
    }
}

export default OilTempChart;